import { lazy } from 'react';
import { AddonBlueprint } from '@backstage/plugin-techdocs-react/alpha';
import { createFrontendModule } from '@backstage/frontend-plugin-api';

/**
 * Custom Mermaid addon that passes our desired config (theme + line color).
 *
 * The auto-discovered addon from `backstage-plugin-techdocs-addon-mermaid`
 * does not support passing props. We disable it via app-config.yaml and
 * register this one instead.
 */
const MermaidWithConfig = lazy(() =>
  import('backstage-plugin-techdocs-addon-mermaid').then(m => ({
    default: () => (
      <m.Mermaid
        config={{ theme: 'default', themeVariables: { lineColor: '#000000' } }}
      />
    ),
  })),
);

const mermaidAddon = AddonBlueprint.make({
  name: 'mermaid-custom',
  params: {
    name: 'MermaidCustom',
    location: 'Content',
    component: MermaidWithConfig,
  },
});

export const mermaidAddonModule = createFrontendModule({
  pluginId: 'techdocs',
  extensions: [mermaidAddon],
});
